import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { IrbSettingsService } from '@irb/irb-settings/irb-settings.service';
import { MatAccordion } from '@angular/material/expansion';
import { IrbSettingsEvents } from '@irb-common/events';
import { AppService } from '@irb/app.service';

@Component({ standalone: false,
  selector: 'irb-settings-dialog-banner',
  templateUrl: './settings-dialog-banner.component.html',
  styleUrls: ['./settings-dialog-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class SettingsDialogBannerComponent implements OnInit {
  @Input() accordian: MatAccordion;
  @Input() showUnsavedChangesWarning: boolean;
  @Input() isModified: boolean;
  @Input() showExpandControls: boolean = true;
  @Input() validationErrorTemplates: TemplateRef<any>[];
  @Output() save = new EventEmitter<boolean>();

  constructor(public iss: IrbSettingsService, private as: AppService) {}

  ngOnInit() {
  }

  closeWithoutSave() {
    this.as.fireEvent(IrbSettingsEvents.CLOSE_WITHOUT_SAVE);
  }

  onSave() {
    this.save.emit(true);
  }
}
